import * as msal from 'msal';

const CLIENT_ID = '6b3e044a-07bb-420e-bebc-054985d5fed2';
const SCOPES = ['openid', 'user.read'];

export class AuthService {
  private readonly tokenRequest: msal.AuthenticationParameters = {
    scopes: SCOPES
  };
  private readonly logger: msal.Logger = new msal.Logger(
    (level: msal.LogLevel, message: string, containsPii: boolean) => {
      console.log(message);
    },
    { level: msal.LogLevel.Warning }
  );
  private readonly userAppAgent: msal.UserAgentApplication = new msal.UserAgentApplication(
    {
      auth: {
        clientId: CLIENT_ID,
        navigateToLoginRequestUrl: false,
        redirectUri: `${window.location.origin}/auth.html`
      },
      cache: { cacheLocation: 'localStorage' },
      system: { logger: this.logger }
    }
    // CLIENT_ID,
    // '',
    // this.tokenRecievedCallback,
    // {
    //   cacheLocation: 'localStorage',
    //   logger: this.logger,
    //   navigateToLoginRequestUrl: false,
    //   redirectUri: `${window.location.origin}/auth.html`
    // }
  );
  /**
   * Opens Popup to instigate authentication flow.
   *
   * @returns {Promise<string>} IdToken
   * @memberof AuthService
   */
  async openLoginPopup(): Promise<string> {
    let response: msal.AuthResponse;
    try {
      this.cleanUpMsal();
      response = await this.userAppAgent.loginPopup(this.tokenRequest);
      return response.idToken.rawIdToken;
    } catch (e) {
      console.error(e);
      //
      return 'blah';
    }
  }

  /**
   * Attempt to get the access token either from storage or remotely.
   *
   * @memberof AuthService
   */
  async getGraphTokenSilent(logError: boolean = false): Promise<string> {
    let accessToken: string = '';
    try {
      const response = await this.userAppAgent.acquireTokenSilent(this.tokenRequest);
      console.log('authService.getGraphTokenSilent response', response);
      accessToken = response.accessToken;
    } catch (e) {
      console.error('authService.getGraphTokenSilent', e);
      //
    }

    return accessToken;
  }

  /**
   * Attempt to get the access token either from stoage or remotely.
   *
   * @memberof AuthService
   */
  async getAccessTokenSilent(logError: boolean = false): Promise<string> {
    let accessToken: string = '';
    try {
      const response = await this.userAppAgent.acquireTokenSilent({ scopes: [CLIENT_ID] });
      if (response.accessToken) {
        accessToken = response.accessToken;
      } else {
        return await this.getAccessTokenSilent();
      }
    } catch (e) {
      console.error('authService.getAccessTokenSilentERROR', e);
      //
    }

    return accessToken;
  }

  /**
   * Logout and remove all local context
   *
   * @memberof AuthService
   */
  logout(): void {
    this.userAppAgent.logout();
    this.cleanUpMsal();
  }

  /**
   * A method to check whether the user is currently logged in
   *
   * @returns {Promise<boolean>}
   * @memberof AuthService
   */
  async isUserLoggedIn(): Promise<boolean> {
    const token = await this.getAccessTokenSilent();
    return Boolean(token);
  }

  private cleanUpMsal(): void {
    const keys = Object.keys(localStorage).filter(x => {
      const key = x.toLowerCase();
      return key.includes('msal') || key.includes('microsoft');
    });
    keys.forEach(x => localStorage.removeItem(x));
  }
}
